import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { IQuestionnaireAnswer, QuestionnaireAnswer } from '../QuestionnaireAnswer.ts';
import { QuestionnaireAnswerApi } from '../../../apis/QuestionnaireAnswerApi/QuestionnaireAnswerApi.ts';
import { useBaseQuery } from '../../../queryDefaults/baseQueries/useBaseQuery.tsx';

export function useGetQuestionnaireAnswerByTaskIdAndToken(taskId?: string | null, token?: string | null) {
    return useBaseQuery({
        queryKey: [QueryKeys.questionnaireAnswer],
        queryFn: async () => {
            const result: IQuestionnaireAnswer = await QuestionnaireAnswerApi.getQuestionnaireAnswerByTaskIdAndToken(
                taskId!,
                token!,
            );
            return new QuestionnaireAnswer(result);
        },
        enabled: !!token && !!taskId,
        staleTime: 3600000, //1h
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        refetchInterval: false,
    });
}
